// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"b7e9c668","50":"7348fedd","180":"7348fedd","237":"7348fedd","467":"7348fedd","535":"ce63fb3c","552":"bfce7075","595":"92dc08e8","718":"7348fedd"}[chunkId] + ".chunk.css";
};